import React from 'react';

import { useLocation } from 'react-router-dom';

import { ReactComponent as InfoIcon } from '@pkg/assets/icons/info.svg';
import { Tooltip } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

import { ActiveLine, Count, Divider, TabLink, Wrapper } from './styles';

interface Tab {
    label: string;
    path: string;
    counter?: number;
    info?: string;
}

const TABS: Tab[] = [
    {
        label: 'NFTs',
        path: '',
    },
    {
        label: 'Links',
        path: 'links',
        info: 'Links allow you to share things you love with the world.',
    },
    {
        label: 'Yats',
        path: 'yats',
    },
    {
        label: 'Wishlists',
        path: 'wishlists',
    },
];

const TABS_SECONDARY: Tab[] = [
    {
        label: 'History',
        path: 'history',
    },
    {
        label: 'Offers',
        path: 'offers',
        counter: 3,
    },
];

export const TabNav = () => {
    const eid = useAppSelector((state) => state.yatPage.eid);
    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const marketplaceEnabled = useAppSelector((state) => state.featureFlags.features.marketplaceEnabled);
    const location = useLocation();

    function renderTabs(tabs: Tab[]) {
        return (
            <>
                {tabs.map(({ label, path, counter, info }) => {
                    const to = path === '' ? `/${eid}${location.search}` : `/${eid}/${path}${location.search}`;

                    return (
                        <TabLink key={label} to={to} end>
                            {({ isActive }) => (
                                <>
                                    {label}
                                    {counter && <Count>{counter}</Count>}
                                    {isActive && <ActiveLine layoutId="tabnav-underline" />}
                                    {info && (
                                        <Tooltip trigger={<InfoIcon />} placement="bottom" variant="secondary">
                                            {info}
                                        </Tooltip>
                                    )}
                                </>
                            )}
                        </TabLink>
                    );
                })}
            </>
        );
    }

    return (
        <Wrapper>
            {renderTabs(TABS)}
            {isPageOwner && marketplaceEnabled ? (
                <>
                    <Divider />
                    {renderTabs(TABS_SECONDARY)}
                </>
            ) : null}
        </Wrapper>
    );
};
